import React from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col
} from "reactstrap";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import ContactUS from "views/examples/ContactUs";
import styled from 'styled-components'
import DemoFooter from "components/Footers/DemoFooter.js";
import InfiniteCarousel from 'react-leaf-carousel';
// import counterpart from 'counterpart'
// import Translate from 'react-translate-component';


import img0 from 'assets/img/companies/0.png'
import img1 from 'assets/img/companies/1.jpg'
import img2 from 'assets/img/companies/2.png'
import img3 from 'assets/img/companies/3.jpg'
import img4 from 'assets/img/companies/4.png'
import img5 from 'assets/img/companies/5.jpg'
import img7 from 'assets/img/companies/7.jpg'
import img8 from 'assets/img/companies/8.jpg'
import img9 from 'assets/img/companies/9.png'
import img10 from 'assets/img/companies/10.png'
import Logistics from '../../assets/img/Logistics1.png';
import { useTranslation } from 'react-i18next';

const ImgStyled = styled.img`
    max-width: 100%;
    height: auto;
`
const ImgBlock = styled.div`
    width: 120px;
    height: 120px;
    height: auto;
    float: left;
    margin: 3px;
    padding: 3px;
`
const CenterImage = styled.img`
    width: 350px;
    height: 80%;
`



const LandingPage = () => {

    const { t, i18n } = useTranslation();
  
  return (
    <>
      <IndexNavbar />
      <IndexHeader />
      <div className="main">
        <div className="section text-center">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="9">
                <h2 className="title">{t('WhatOffer')} </h2>
              </Col>
            </Row>
            <br />
            <br />
            <Row>
              <Col md="4">
                <div className="info">
                  <div className="icon icon-info">
                    <i className="nc-icon nc-album-2" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">{t('LogisticsService')}</h4>
                    <br/>
                    <p className="description">
                    {t('LogisticsServiceText')}
                    </p>
                  </div>
                </div>
              </Col>
              <Col md="4">
              <CenterImage src={Logistics} alt="image"/>
              </Col>
              <Col md="4">
                <div className="info">
                  <div className="icon icon-info">
                    <i className="nc-icon nc-bulb-63" />
                  </div>
                  <div className="description">
                    <h4 className="info-title">{t('IndividualService')}</h4>
                    <br/>
                    <p>
                      {t('IndividualServiceText')}
                    </p>
                  </div>
                </div>
              </Col>
              
            </Row>
          </Container>
        </div>
        <div className="section section-dark text-center">
          <Container>
            <h2 className="title">{t('Reviews')}</h2>
            <Row>
              <Col md="4">
                <Card className="card-profile card-plain">
                  <div className="card-avatar">
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <img
                        alt="..."
                        src={require("assets/img/faces/boy1.png")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <div className="author">
                        <CardTitle tag="h4">{t('FirstReviewName')}</CardTitle>
                        <h6 className="card-category">{t('FirstReviewWork')}</h6>
                      </div>
                    </a>
                    <p className="card-description text-center">
                    {t('FirstReviewText')}
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card className="card-profile card-plain">
                  <div className="card-avatar">
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <img
                        alt="..."
                        src={require("assets/img/faces/boy.png")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <div className="author">
                        <CardTitle tag="h4">{t('SecondReviewName')}</CardTitle>
                        <h6 className="card-category">{t('SecondReviewWork')}</h6>
                      </div>
                    </a>
                    <p className="card-description text-center">
                    {t('SecondReviewText')}
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col md="4">
                <Card className="card-profile card-plain">
                  <div className="card-avatar">
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <img
                        alt="..."
                        src={require("assets/img/faces/images.png")}
                      />
                    </a>
                  </div>
                  <CardBody>
                    <a href="#pablo" onClick={e => e.preventDefault()}>
                      <div className="author">
                        <CardTitle tag="h4">{t('ThirdReviewName')}</CardTitle>
                        <h6 className="card-category">{t('ThirdReviewWork')}</h6>
                      </div>
                    </a>
                    <p className="card-description text-center">
                    {t('ThirdReviewText')}
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <div>
          <Container>
          <Row>
              <Col className="ml-auto mr-auto" md="4">
                <h2 className="title">{t('OurPartners')}</h2>
              </Col>
            </Row>
            <InfiniteCarousel
              breakpoints={[
                {
                  breakpoint: 500,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                  },
                },
              ]}
                dots={true}
                showSides={true}
                sidesOpacity={.5}
                sideSize={.1}
                slidesToScroll={4}
                slidesToShow={4}
                scrollOnDevice={true}
              >
              <ImgBlock>
                <ImgStyled
                  alt=''
                  src={img0}
                />
              </ImgBlock>
              <ImgBlock>
                <ImgStyled
                  alt=''
                  src={img1}
                />
              </ImgBlock>
              <ImgBlock>
                <ImgStyled
                  alt=''
                  src={img2}
                />
              </ImgBlock>
              <ImgBlock>
                <ImgStyled
                  alt=''
                  src={img3}
                />
              </ImgBlock>
              <ImgBlock>
                <ImgStyled
                  alt=''
                  src={img4}
                />
              </ImgBlock>
              <ImgBlock>
                <ImgStyled
                  alt=''
                  src={img5}
                />
              </ImgBlock>
              <ImgBlock>
                <ImgStyled
                  alt=''
                  src={img7}
                />
              </ImgBlock>
              <ImgBlock>
                <ImgStyled
                  alt=''
                  src={img8}
                />
              </ImgBlock>
              <ImgBlock>
                <ImgStyled
                  alt=''
                  src={img9}
                />
              </ImgBlock>
              <ImgBlock>
                <ImgStyled
                  alt=''
                  src={img10}
                />
              </ImgBlock>
          </InfiniteCarousel>  
          </Container>
        </div>
        <ContactUS />
      </div>
      <DemoFooter />
    </>
  )};


export default LandingPage;
